import { useState } from "react";
import { Controller } from "react-hook-form";
import { useIntl } from "react-intl";

import {
  DrawerContent,
  DrawerTopBar,
  SwipeableDrawer,
} from "@/components/Drawer";
import { TravellerDetails } from "@/features/travellers/components/TravellerDetails";
import type { Traveller } from "@/features/travellers/types/types";

import { MainTravellerRadioButtons } from "./MainTravellerRadioButtons";

type Props = {
  travelDate: Date;
  selectedTravellers: Traveller[];
};

export const MainTravellerSelectionCard = ({
  travelDate,
  selectedTravellers,
}: Props) => {
  const intl = useIntl();
  const [traveller, setTraveller] = useState<Traveller | null>(null);

  return (
    <div className="section-card">
      <div className="mb-1 text-lg font-medium text-text-primary">
        {intl.formatMessage({
          defaultMessage: "Travellers",
          description:
            "Title for the main traveller selection section in the hotel flow",
        })}
      </div>

      <div className="mb-4 text-sm text-text-tertiary">
        {intl.formatMessage({
          defaultMessage:
            "Please select the traveller which will be marked as the main",
          description:
            "Description for the main traveller selection section in the hotel flow",
        })}
      </div>

      <div className="-mx-2">
        <Controller
          name="leadTraveler"
          render={({ field }) => (
            <MainTravellerRadioButtons
              {...field}
              travelDate={travelDate}
              selectedTravellers={selectedTravellers}
              onDetailsClick={(selected) => {
                setTraveller(selected);
              }}
            />
          )}
        />
      </div>

      <SwipeableDrawer
        open={traveller !== null}
        onClose={() => setTraveller(null)}
        backgroundColor="background"
      >
        <DrawerTopBar
          title={intl.formatMessage({
            defaultMessage: "Traveller details",
            description: "Title for the traveller details drawer",
          })}
          onCloseClick={() => setTraveller(null)}
        />

        <DrawerContent>
          {traveller ? (
            <div className="section-card">
              <TravellerDetails traveller={traveller} />
            </div>
          ) : null}
        </DrawerContent>
      </SwipeableDrawer>
    </div>
  );
};
